import Layout from 'components/layout/Layout'
import BrusselsAirport from 'features/brussels-airport/BrusselsAirport'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import { DEFAULT_NAMESPACES, SIMULATION_NAMESPACES } from 'constants/i18n'
import { cmsLib, producersLib } from 'lib'
import { faqCategoriesSlugs } from 'constants/faq-categories'
import { FAQCategories } from 'features/faq-page/types'
import { BrusselsAirportProps } from 'features/brussels-airport/types'
import { BRUSSELS_AIRPORT_PRODUCER_SLUG } from 'constants/customer-flow'
import { SeoProps } from 'components/seo/types'
import { useTranslation } from 'next-i18next/pages'

const BrusselsAirportPage = (props: BrusselsAirportProps) => {
  // i18n
  const { t } = useTranslation('brusselsAirport')

  const seo: SeoProps = {
    description: t('seo.description'),
    title: t('seo.title'),
    image: 'https://res.cloudinary.com/bolt-energie/image/upload/v1737462582/website/brussels-airport/thumbnail.png'
  }

  return (
    <Layout {...{ seo }}>
      <BrusselsAirport {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const [brusselsAirportProducer, categories] = await Promise.all([
    producersLib.getProducerBySlug(BRUSSELS_AIRPORT_PRODUCER_SLUG),
    cmsLib.getFaqCategories(faqCategoriesSlugs[FAQCategories.BRUSSELS_AIRPORT], locale)
  ])

  if (!brusselsAirportProducer) {
    return {
      notFound: true,
      revalidate: 100
    }
  }

  return {
    props: {
      brusselsAirportProducer,
      categories,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, ...SIMULATION_NAMESPACES, 'brusselsAirport'], i18nConfig))
    },
    revalidate: 600 // re-generate page when a request comes in, once every 10 minutes
  }
}

export default BrusselsAirportPage
